
import axios from 'axios'
import { TagRestClient } from 'http/resources'
import { ErrorManager } from 'services'

function getTags(page, pageCount, criteria) {
    return async dispatch => {
        try {
            dispatch({
                type: 'TAGS_FETCH_TAGS_START',
                payload: {
                    isActiveSearch: typeof criteria !== 'undefined',
                }
            })
            
            const response = await new TagRestClient(true).getTags(page, pageCount, criteria)

            dispatch({
                type: 'TAGS_FETCH_TAGS_SUCCESS',
                payload: {
                    page,
                    pageCount,
                    tags: response.data.items,
                    totals: response.data.totalItems,
                }
            })
            
        } catch (e) {
            if (e instanceof axios.Cancel) {
                // Nothing to do, just canceled request by next request
            } else {
                dispatch({
                    type: 'TAGS_FETCH_TAGS_FAIL'
                })
    
                dispatch({
                    type: 'ERROR_SET',
                    payload: {
                        title: 'Error en la operación!',
                        description: 'Ha ocurrido un error al intentar obtener los tags'
                    }
                })
            }
        }
    }
}

function getTag(id) {
    return async dispatch => {
        try {
            dispatch({
                type: 'TAGS_FETCH_TAG_START'
            })

            const response = await new TagRestClient(true).getTag(id)

            dispatch({
                type: 'TAGS_FETCH_TAG_SUCCESS',
                payload: {
                    tag: response.data
                }
            })
        } catch (e) {
            dispatch({
                type: 'TAGS_FETCH_TAG_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'Error en la operación!',
                    description: 'Ha ocurrido un error al intentar obtener el tag'
                }
            })
        }
    }
}

function saveTag(id, data, patch) {
    return async dispatch => {
        try {
            dispatch({
                type: 'TAGS_SAVE_TAG_START',
                payload: {
                    id,
                    patch,
                }
            })

            if (id && !patch) {
                await new TagRestClient(true).updateTag(id, data)
            } else if (id && patch) {
                await new TagRestClient(true).patchTag(id, data)
            } else {
                await new TagRestClient(true).createTag(data)
            }

            dispatch({
                type: 'TAGS_SAVE_TAG_SUCCESS',
                payload: {
                    id,
                    data,
                    patch,
                }
            })

            dispatch({
                type: 'SUCCESS_SET',
                payload: {
                    title: 'Operación Exitosa!',
                    description: id
                        ? 'El tag se ha actualizado correctamente'
                        : 'El tag se ha creado correctamente'
                }
            })
        } catch (e) {
            dispatch({
                type: 'TAGS_SAVE_TAG_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'UPS! Ha ocurrido un error en la operación.',
                    description: ErrorManager.toMessage(e),
                }
            })
        } finally {
            dispatch({
                type: 'TAGS_SAVE_TAG_RESET'
            })
        } 
    }
}

function setFormPropertyValue(property, value) {
    return {
        type: 'TAGS_FORM_PROPERTY_VALUE_SET',
        payload: {
            property,
            value
        }
    }
}

function reset(type) {
    return {
        type,
    }
}


export const TagsActions = {
    getTags,
    getTag,
    saveTag,
    setFormPropertyValue,
    reset,
}